import React, { useEffect } from 'react';
import ConversationalUi from './ConversationalUI';
import { Helmet } from 'react-helmet';
import {
  usePostPanStore,
  useBankStatementStore,
  useAuthStore,
} from '../../redux';

// Components in Layout Component
// 1. Left Sidebar
// 2. Top Navbar
// 3. Right Side Login Acct Bullet

const withDashboardMenuLayout = ({
  childComponent,
  title = 'Fibe || Earlysalary',
  isLeftProgressBarPresent = false,
  isCustomLeftSideComp = false,
  customLeftSideComp,
}) => {
  const { journeyApproved, surrogateApproved } = usePostPanStore();
  const { bsSuccess, bsApproved } = useBankStatementStore();
  const { authState, customerRefNum } = useAuthStore();
  const { marketingQueryParams } = authState;
  const { utmSource, medium } = marketingQueryParams;
  if (window.location.pathname === '/post-pan' && journeyApproved) {
    fbq('track', 'ViewContent');
  } else if (window.location.pathname === '/bank-statement' && bsSuccess) {
    fbq('track', 'ViewContent');
  } else if (window.location.pathname === '/kyc-process') {
    fbq('track', 'ViewContent');
  }

  const element = document.getElementById('allincall-popup-wrapper');
  const chatbotElement = document.getElementById('allincall-chat-box');
  useEffect(() => {
    if (window.location.pathname !== '/chatbot') {
      if (element) {
        element.remove();
        chatbotElement.remove();
      }
    }
  }, []);
  return (
    <div>
      <Helmet>
        {window.location.pathname === '/post-pan' ? (
          <script
            type="text/javascript"
            dangerouslySetInnerHTML={{
              __html: gtag('event', 'conversion', {
                send_to: 'AW-822575141/I5jmCLTGtJMYEKWAnogD',
              }),
            }}
          ></script>
        ) : null}

        {window.location.pathname === '/post-pan' && journeyApproved ? (
          <script
            type="text/javascript"
            dangerouslySetInnerHTML={{
              __html: gtag('event', 'conversion', {
                send_to: 'AW-822575141/SOXRCJKKqJYYEKWAnogD',
              }),
            }}
          ></script>
        ) : null}

        {window.location.pathname === '/bank-statement' && bsSuccess ? (
          <script
            type="text/javascript"
            dangerouslySetInnerHTML={{
              __html: gtag('event', 'conversion', {
                send_to: 'AW-822575141/kCg6CJSGnZYYEKWAnogD',
              }),
            }}
          ></script>
        ) : null}

        {window.location.pathname === '/kyc-process' ? (
          <script
            type="text/javascript"
            dangerouslySetInnerHTML={{
              __html: gtag('event', 'conversion', {
                send_to: 'AW-822575141/5b3SCOmKpJYYEKWAnogD',
              }),
            }}
          ></script>
        ) : null}
      </Helmet>

      {/* affiliate pixels addition on kyc-process */}

      {/* admattic */}
      {window.location.pathname === '/kyc-process' &&
      utmSource == 'Admattic_Web' ? (
        <img
          alt=""
          height="1"
          width="1"
          style={{ display: 'none', visibility: 'hidden' }}
          src="https://admattic.gotrackier.com/pixel?adid=642fab83fbfd2c510f0ef1bc"
        />
      ) : null}

      {/* analytics_cloud */}
      {window.location.pathname === '/kyc-process' &&
      utmSource == 'AnalyticsCloud_Web' ? (
        <img
          alt=""
          src="https://performance.gotrackier.com/pixel?adid=643e7ff3e7bbeb47c558d8c8"
          width="0px"
          height="0px"
        />
      ) : null}

      {/* axponent */}
      {window.location.pathname === '/kyc-process' &&
      utmSource == 'Axponent_Web' ? (
        <img
          alt=""
          src={`https://axponent.g2afse.com/success.jpg?offer_id=303&custom_field1=${customerRefNum}&afsecure=b7574e15e83cadafd04e25490ad7ced0`}
          width="1"
          height="1"
        />
      ) : null}

      {/* mediainfinity */}
      {window.location.pathname === '/kyc-process' &&
      utmSource == 'Mediafinity_Web' ? (
        <img
          alt=""
          src={`https://themediafinity.sapph.in/click?offer=5399&partner=1000&pcid=${customerRefNum}`}
          width="0px"
          height="0px"
        />
      ) : null}

      {/* affiliate pixels addition on post-pan & bank statement approval screens */}

      {/* Times Internet */}
      {window.location.pathname === '/post-pan' &&
      surrogateApproved &&
      utmSource == 'TimesInternet_Web' ? (
        <img
          alt=""
          src="https://timesinternetlimited187.o18.click/p?o=20344758&m=2731&t=i&event=credit_approved"
          width="0px"
          height="0px"
        />
      ) : null}
      {window.location.pathname === '/bank-statement' &&
      bsApproved &&
      utmSource == 'TimesInternet_Web' ? (
        <img
          alt=""
          src="https://timesinternetlimited187.o18.click/p?o=20344758&m=2731&t=i&event=credit_approved"
          width="0px"
          height="0px"
        />
      ) : null}

      {/* Deman desk */}
      {window.location.pathname === '/post-pan' &&
      surrogateApproved &&
      utmSource == 'DemanDesk_Web' ? (
        <img
          alt=""
          src="https://trk.globaladsmedia.us/pixel?adid=6442786efd6e751f52370851"
          width="0px"
          height="0px"
        />
      ) : null}
      {window.location.pathname === '/bank-statement' &&
      bsApproved &&
      utmSource == 'DemanDesk_Web' ? (
        <img
          alt=""
          src="https://trk.globaladsmedia.us/pixel?adid=6442786efd6e751f52370851"
          width="0px"
          height="0px"
        />
      ) : null}

      {/* Intellect ads */}
      {window.location.pathname === '/post-pan' &&
      surrogateApproved &&
      utmSource == 'INTLCT_WEB' ? (
        <img
          alt=""
          src={`https://www.intellectadz.com/track/conversion.asp?cid=2823&conversionType=1&key=${customerRefNum}&opt1=&opt2=&opt3=`}
          width="1px"
          height="1px"
        />
      ) : null}
      {window.location.pathname === '/bank-statement' &&
      bsApproved &&
      utmSource == 'INTLCT_WEB' ? (
        <img
          alt=""
          src={`https://www.intellectadz.com/track/conversion.asp?cid=2823&conversionType=1&key=${customerRefNum}&opt1=&opt2=&opt3=`}
          width="1px"
          height="1px"
        />
      ) : null}

      {/* Oplifi */}
      {window.location.pathname === '/post-pan' &&
      surrogateApproved &&
      utmSource == 'Oplifi_Web' ? (
        <img
          alt=""
          src="https://oplifi.gotrackier.com/pixel?adid=644a53682bb7e87b8322b9db"
          width="0px"
          height="0px"
        />
      ) : null}
      {window.location.pathname === '/bank-statement' &&
      bsApproved &&
      utmSource == 'Oplifi_Web' ? (
        <img
          alt=""
          src="https://oplifi.gotrackier.com/pixel?adid=644a53682bb7e87b8322b9db"
          width="0px"
          height="0px"
        />
      ) : null}

      {/* Advolt */}
      {window.location.pathname === '/post-pan' &&
      surrogateApproved &&
      utmSource == 'ADVLT_WEB' ? (
        <iframe
          src={`https://advolt.gotrackier.com/pixel?adid=64520757c6240c34c90df31e&txn_id=${customerRefNum}&publisher_id=${medium}`}
          scrolling="no"
          frameborder="0"
          width="1"
          height="1"
        ></iframe>
      ) : null}
      {window.location.pathname === '/bank-statement' &&
      bsApproved &&
      utmSource == 'ADVLT_WEB' ? (
        <iframe
          src={`https://advolt.gotrackier.com/pixel?adid=64520757c6240c34c90df31e&txn_id=${customerRefNum}&publisher_id=${medium}`}
          scrolling="no"
          frameborder="0"
          width="1"
          height="1"
        ></iframe>
      ) : null}

      <ConversationalUi
        childComponent={childComponent}
        isLeftProgressBarPresent={isLeftProgressBarPresent}
        isCustomLeftSideComp={isCustomLeftSideComp}
        customLeftSideComp={customLeftSideComp}
      />
    </div>
  );
};

export default withDashboardMenuLayout;
